// Rács mérete pixelben
export const GRID_SIZE = 20;

// Skála: 1 méter = hány pixel
export const METERS_TO_PX = 40;

// Zoom határok
export const ZOOM_MIN = 0.3;
export const ZOOM_MAX = 2.5;

// Előre definiált vendég kategóriák
export const PREDEFINED_CATEGORIES = [
  { value: 'bride', label: 'Menyasszony oldala' },
  { value: 'groom', label: 'Vőlegény oldala' },
  { value: 'bridesmaid', label: 'Koszorúslány' },
  { value: 'groomsman', label: 'Vőfély' },
  { value: 'family', label: 'Család' },
  { value: 'friend', label: 'Barát' },
];

// Fix kategória színek
export const CATEGORY_COLORS = {
  bride:      '#f48fb1',  // rózsaszín
  groom:      '#90caf9',  // kék
  bridesmaid: '#ce93d8',  // lila
  groomsman:  '#80cbc4',  // türkiz
  family:     '#ffcc80',  // borostyán
  friend:     '#a5d6a7',  // zöld
  default:    '#e0e0e0',  // szürke (ismeretlen / nincs)
};

// Szabad szín paletta egyéni kategóriákhoz
const CUSTOM_COLOR_PALETTE = [
  '#ef9a9a', '#ffcc80', '#ffe082', '#c5e1a5',
  '#80deea', '#81d4fa', '#b39ddb', '#f48fb1',
];

let _colorIndex = 0;
const _customColorMap = {};

/**
 * Visszaadja egy kategória színét.
 * Ha előre definiált → fix szín.
 * Ha egyéni → automatikusan kiosztott paletta szín.
 */
export function getCategoryColor(category) {
  if (!category) return CATEGORY_COLORS.default;
  if (CATEGORY_COLORS[category]) return CATEGORY_COLORS[category];
  if (!_customColorMap[category]) {
    _customColorMap[category] = CUSTOM_COLOR_PALETTE[_colorIndex % CUSTOM_COLOR_PALETTE.length];
    _colorIndex++;
  }
  return _customColorMap[category];
}

/**
 * Visszaadja egy kategória feliratát.
 * Előre definiáltnál a magyar nevet, egyéni esetén magát az értéket.
 */
export function getCategoryLabel(category) {
  const found = PREDEFINED_CATEGORIES.find(c => c.value === category);
  return found ? found.label : (category || '–');
}

// Paletta modul definíciók
export const PALETTE_MODULES = [
  {
    type: 'round_table',
    label: 'Kerek asztal',
    icon: 'round_table',
    defaultWidth: 100,
    defaultHeight: 100,
    defaultCapacity: 8,
    isTable: true,
  },
  {
    type: 'rect_table',
    label: 'Négyszög asztal',
    icon: 'rect_table',
    defaultWidth: 160,
    defaultHeight: 80,
    defaultCapacity: 8,
    isTable: true,
  },
  {
    type: 'stage',
    label: 'Zenekar / Pódium',
    icon: 'stage',
    defaultWidth: 200,
    defaultHeight: 100,
    isTable: false,
  },
  {
    type: 'dancefloor',
    label: 'Táncparkett',
    icon: 'dancefloor',
    defaultWidth: 200,
    defaultHeight: 200,
    isTable: false,
  },
  {
    type: 'photowall',
    label: 'Fotófal',
    icon: 'photowall',
    defaultWidth: 120,
    defaultHeight: 60,
    isTable: false,
  },
  {
    type: 'bar',
    label: 'Bár',
    icon: 'bar',
    defaultWidth: 160,
    defaultHeight: 60,
    isTable: false,
  },
];

// Modul típus → szín + ikon betű
export const MODULE_STYLES = {
  round_table:  { bgcolor: '#c8e6c9', color: '#2e7d32', label: 'A' },
  rect_table:   { bgcolor: '#c8e6c9', color: '#2e7d32', label: 'A' },
  stage:        { bgcolor: '#ffe0b2', color: '#e65100', label: '♪' },
  dancefloor:   { bgcolor: '#e1bee7', color: '#6a1b9a', label: '♬' },
  photowall:    { bgcolor: '#fce4ec', color: '#880e4f', label: '📷' },
  bar:          { bgcolor: '#fff9c4', color: '#f57f17', label: '🍸' },
};

// Kapacitásjelző küszöbértékek
export const CAPACITY_THRESHOLDS = {
  ok:      { max: 0.7, color: '#4caf50' }, // < 70% → zöld
  warning: { max: 0.9, color: '#ff9800' }, // 70–90% → sárga
  full:    { max: 1.0, color: '#f44336' }, // > 90% → piros
};

export function getCapacityColor(filled, capacity) {
  if (!capacity) return CAPACITY_THRESHOLDS.ok.color;
  const ratio = filled / capacity;
  if (ratio <= CAPACITY_THRESHOLDS.ok.max) return CAPACITY_THRESHOLDS.ok.color;
  if (ratio <= CAPACITY_THRESHOLDS.warning.max) return CAPACITY_THRESHOLDS.warning.color;
  return CAPACITY_THRESHOLDS.full.color;
}

// RSVP státusz suffix a vendégnevekhez (csak nem-ATTENDING esetén)
export function getRsvpSuffix(status) {
  if (status === 'NOT_ATTENDING') return ' (Nem jön)';
  if (status === 'MAYBE') return ' (Talán)';
  if (status === 'NO_RESPONSE') return ' (Nincs válasz)';
  return '';
}

// Default helyszín méret pixelben (20m x 15m)
export const DEFAULT_VENUE = { width: 800, height: 600 };
